export const missingDataHandlingEnum = {
  OMIT: 'OMIT',
  NULL_VALUE: 'NULL_VALUE',
  BLANK_VALUE: 'BLANK_VALUE',
} as const

export type MissingDataHandlingEnum = (typeof missingDataHandlingEnum)[keyof typeof missingDataHandlingEnum]

export type MissingDataHandling = MissingDataHandlingEnum